import { SurveyV2 } from '@act/shared/data-transfer-objects';

export function handleDeletion(
  content: SurveyV2.CreateSurveyJSONDto,
  type: 'checkpoint' | 'option' | 'prompt' | 'question' | 'survey',
  questionIndex: number,
  optionIndex?: number
): SurveyV2.CreateSurveyJSONDto {
  let updatedContent: SurveyV2.CreateSurveyJSONDto;

  switch (type) {
    case 'checkpoint':
      if (optionIndex) {
        updatedContent = {
          ...content,
          surveyContent: {
            ...content.surveyContent,
            surveyVersion: {
              ...content.surveyContent.surveyVersion,
              questions: content.surveyContent.surveyVersion.questions.map(
                (question, index) => {
                  if (index === questionIndex) {
                    return {
                      ...question,
                      options: question.options.map((option, index) => {
                        if (index === optionIndex) {
                          return {
                            ...option,
                            checkpoint: null,
                          };
                        }
                        return option;
                      }),
                    };
                  }
                  return question;
                }
              ),
            },
          },
        };
      } else {
        updatedContent = {
          ...content,
          surveyContent: {
            ...content.surveyContent,
            surveyVersion: {
              ...content.surveyContent.surveyVersion,
              questions: content.surveyContent.surveyVersion.questions.map(
                (question, index) => {
                  if (index === questionIndex) {
                    return {
                      ...question,
                      checkpoint: null,
                    };
                  }
                  return question;
                }
              ),
            },
          },
        };
      }
      break;
    case 'option':
      if (!optionIndex) {
        return updatedContent || content;
      }
      updatedContent = {
        ...content,
        surveyContent: {
          ...content.surveyContent,
          surveyVersion: {
            ...content.surveyContent.surveyVersion,
            questions: content.surveyContent.surveyVersion.questions.map(
              (question, index) => {
                if (index === questionIndex) {
                  return {
                    ...question,
                    options: question.options.map((option, index) => {
                      if (index === optionIndex) {
                        return {
                          ...option,
                          prompt: null,
                        };
                      }
                      return option;
                    }),
                  };
                }
                return question;
              }
            ),
          },
        },
      };
      break;
    case 'prompt':
      if (optionIndex) {
        updatedContent = {
          ...content,
          surveyContent: {
            ...content.surveyContent,
            surveyVersion: {
              ...content.surveyContent.surveyVersion,
              questions: content.surveyContent.surveyVersion.questions.map(
                (question, index) => {
                  if (index === questionIndex) {
                    return {
                      ...question,
                      options: question.options
                        .filter((_, index) => index !== optionIndex)
                        .map((option, index) => ({
                          ...option,
                          sortOrder: index + 1,
                        })),
                    };
                  }
                  return question;
                }
              ),
            },
          },
        };
      } else {
        updatedContent = {
          ...content,
          surveyContent: {
            ...content.surveyContent,
            surveyVersion: {
              ...content.surveyContent.surveyVersion,
              questions: content.surveyContent.surveyVersion.questions.map(
                (question, index) => {
                  if (index === questionIndex) {
                    return {
                      ...question,
                      prompt: null,
                    };
                  }
                  return question;
                }
              ),
            },
          },
        };
      }
      break;
    case 'question':
      updatedContent = {
        ...content,
        surveyContent: {
          ...content.surveyContent,
          surveyVersion: {
            ...content.surveyContent.surveyVersion,
            questions: content.surveyContent.surveyVersion.questions
              .filter((_, index) => index !== questionIndex)
              .map((question, index) => ({
                ...question,
                key: `quest-${index + 1}`,
                sortOrder: index + 1,
              })),
          },
        },
      };
      break;
    default:
      break;
  }

  return updatedContent;
}
